/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import isEqual from 'lodash/isEqual'
import pick from 'lodash/pick'
import React, {useEffect, useState} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {isEmpty} from 'react-redux-firebase'
import PageScaffold from '../../components/app/page-scaffold'
import {routes} from '../../utils/config'
import {trimFieldStringValues} from '../../utils/validation'
import {updateUserProfile} from '../persistence/auth-actions'
import ProfileUserCard from './profile-user-card'
import CenteredBlock from '../../components/app/centered-block'
import {BackButton} from '../../components/app'
import RowBlock from '../../components/app/row-block'

const INITIAL_STATE = {
  firstName: '',
  lastName: '',
  displayName: '',
}

const Profile = () => {
  const {loading, profile} = useSelector(
    state => ({profile: state.firebase.profile, loading: state.app.loading}),
    shallowEqual,
  )

  const dispatch = useDispatch()

  const [currentProfile, setCurrentProfile] = useState(INITIAL_STATE)

  const profileUpdates = trimFieldStringValues(currentProfile)

  const hasChanged = !isEqual(profileUpdates, pick(profile, Object.keys(INITIAL_STATE)))

  useEffect(() => {
    if (!isEmpty(profile))
      setCurrentProfile(state => ({
        ...state,
        ...pick(profile, ['firstName', 'lastName', 'displayName']),
      }))
  }, [profile])

  const handleInputChange = ({target}) => {
    setCurrentProfile(state => ({...state, [target.name]: target.value}))
  }

  const handleSubmit = async event => {
    event.preventDefault()
    if (!hasChanged) return
    dispatch(updateUserProfile(profileUpdates))
  }

  if (isEmpty(profile)) return null

  return (
    <RowBlock>
      <CenteredBlock>
        <RowBlock>
          <BackButton />
          <PageScaffold pageTitle={routes.profile.name}>
            <ProfileUserCard
              profile={profile}
              currentProfile={currentProfile}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              loading={loading}
              changed={hasChanged}
            />
          </PageScaffold>
        </RowBlock>
      </CenteredBlock>
    </RowBlock>
  )
}

export default Profile
